import React from "react";
import WebView from "react-native-webview";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorRouteProp,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

type Props = {
  navigation: UserLoggedInNavigatorNavigationProp<"EmaginWebview">;
  route: UserLoggedInNavigatorRouteProp<"EmaginWebview">;
};

export function EmaginWebview(props: Props) {
  const insets = useSafeAreaInsets();
  if (Platform.OS === "web") {
    return (
      <iframe
        style={{ height: "100%" }}
        src={`https://www.e-magin.se/latestpaper/${props.route.params.eMaginId}/paper`}
      />
    );
  }
  return (
    <WebView
      source={{
        uri: `https://www.e-magin.se/latestpaper/${props.route.params.eMaginId}/paper`,
      }}
      automaticallyAdjustContentInsets
      automaticallyAdjustsScrollIndicatorInsets
      allowsBackForwardNavigationGestures
      startInLoadingState
      decelerationRate={Platform.OS === "ios" ? "normal" : undefined}
      containerStyle={{
        paddingBottom: Platform.OS === "ios" ? insets.bottom : 0,
      }}
    />
  );
}
